export const Features = {
  START_CONVERSATION: 1,
  SEARCH_ACTIVITIES: 2,
  CREATE_ACTIVITIES: 3,
  SEARCH_GROUPS: 4,
  CREATE_GROUPS: 5,
}
